/*
  Fokusrahmen nur fuer die Tastatur. Nach einem Fingertipp oder Mausklick merkt sich
  das Dokument "Zeiger" und blendet den Rahmen aus, die Tabulator- und Pfeiltasten
  holen ihn zurueck. Ohne dieses Skript bleibt der Rahmen sichtbar, das ist der
  sichere Zustand.
*/

const TASTEN = new Set(['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End']);
const wurzel = document.documentElement;

document.addEventListener('pointerdown', () => wurzel.setAttribute('data-pointer', ''), true);
document.addEventListener(
  'keydown',
  (event) => {
    if (TASTEN.has(event.key)) wurzel.removeAttribute('data-pointer');
  },
  true
);
